// Basic
import { useMemo } from 'react';
import PropTypes from 'prop-types';
// Common
import splitArrayIntoChunks from '../../../functions/splitArrayIntoChunks';
import genUID from '@/common-utils/functions/generateUniqueId';
// Style
import './CardDeck.scss';

const CardDeck = ({ cardsProps, component, cardsNumberPerRow }) => {

    // As decks make each line the same width, even with a different number of elements
    // it is required to push non-visible cards on the last row to ensure all cards
    // have the same width
    const cardsPropsRows = useMemo(() => {
        return splitArrayIntoChunks(cardsProps, cardsNumberPerRow, { hidden: true })
            .map(row => {
                // Append key property to both rows and cards using genUID helper
                const _rowKey = genUID();
                const cardsWithKeys = row.map(card => ({ ...card, key: genUID() }));
                return { _rowKey, cards: cardsWithKeys };
            });
    }, [cardsProps, cardsNumberPerRow]);


    return (
        <div>
            {cardsPropsRows.map(({ _rowKey, cards }) => (
                <div className='card-deck justify-evenly' key={_rowKey}>
                    {cards.map(cardProps => {
                        if (!cardProps) { return null; }
                        return component({
                            ...cardProps,
                            key: cardProps.key
                        });
                    })}
                </div>
            ))}
        </div>
    );
};

CardDeck.propTypes = {
    component: PropTypes.func.isRequired,
    cardsProps: PropTypes.array.isRequired,
    cardsNumberPerRow: PropTypes.number.isRequired
};

export default CardDeck;